import xs from 'xstream';
import BASE_URL from './variables';
import {deleteInternalAlert, deleteInternalAlertFailed, deleteInternalAlertSuccess, createInternalAlert, createInternalAlertFailed, createInternalAlertSuccess, patchInternalAlert, patchInternalAlertFailed, patchInternalAlertSuccess, resetInternalAlertFormState } from '../reducers/internalAlertForm';
import { resetInternalAlertsState } from '../reducers/internalAlerts';

export function requestUpdateInternalAlertById(sources) {
    
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === patchInternalAlert.type)
        .map(action => ({
            url: BASE_URL + 'api/InternalAlerts/' + action.payload.sendBody.id,
            category: 'requestUpdateInternalAlertById',
            method: 'PUT',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateInternalAlertById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => patchInternalAlertSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateInternalAlertByIdFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateInternalAlertById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => patchInternalAlertFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestCreateInternalAlert(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === createInternalAlert.type)
        .map(action => ({
            url: BASE_URL + 'api/InternalAlerts',
            category: 'requestCreateInternalAlert',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestCreateInternalAlert')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => createInternalAlertSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestCreateInternalAlertFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestCreateInternalAlert')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 201)
        .map(response => createInternalAlertFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function resetInternalAlertsReducers(sources) {
	const dispatched$ = sources.ACTION
		.filter(action => action.type === '@@router/LOCATION_CHANGE')
		.map(action => xs.of(resetInternalAlertFormState(),resetInternalAlertsState())).flatten();

	return {
		ACTION: dispatched$,
	};
}

export function requestDeleteInternalAlert(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === deleteInternalAlert.type)
		.map(action => ({
			url: BASE_URL + `api/InternalAlerts/${action.payload}`,
			category: 'deleteInternalAlert',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('deleteInternalAlert')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => deleteInternalAlertSuccess(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badResponseDeleteInternalAlert(sources) {
	let httpResponse$ = sources.HTTP
		.select('deleteInternalAlert')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => deleteInternalAlertFailed(response));

	return {
		ACTION: httpResponse$
	};
}